'use client';

import { useParams } from 'next/navigation';
import React, { useState, useEffect } from 'react';

import { doTranslation } from '@/app/i18n/client';
import styles from '@/components/global/boarding-pass/find-boarding-pass.module.scss';
import Button from '@/components/global/buttons/button';
import ButtonTertiary from '@/components/global/buttons/button-tertiary';
import Input from '@/components/global/forms/input';
import { useCustomerDetail } from '@/context/customer-detail-context';
import { getReservation } from '@/apis/tds';

type Props = {
  onClose: () => void;
  onError: () => void;
};

const FindBoardingPass = (props: Props): React.JSX.Element => {
  const { lng }: any = useParams();

  const { t } = doTranslation(lng);
  const [orderNumber, setOrderNumber] = useState<null | string>(null);
  const [lastName, setLastName] = useState<null | string>(null);
  const [promptText, setPromptText] = useState<string>(t("Enter your order number and buyer's last name to view your ticket."));
  const { customer } = useCustomerDetail();

  useEffect(() => {
    if (customer && customer.lastName) {
      setLastName(customer.lastName);
      setPromptText(t("Enter your order number to view your ticket."));
    }
  }, [customer, t]);

  const handleClick = async () => {
    if (!orderNumber) {
      props.onError();
    }
    try {
      const response = await getReservation(orderNumber || '', lastName);
      if (response.confirmationCode) {
        window.location.href = `${process.env.NEXT_PUBLIC_TRAILWAYS_SITE_BASE}/account/#/boarding-pass?confirmation=${response.confirmationCode}`;
      } else {
        props.onError();
      }
    } catch (e) {
      props.onError();
    }
    props.onClose();
  };

  return (
    <>
      <div className={styles.content}>
        <div className={styles.text}>{promptText}</div>
        <div className={styles.inputs}>
          <Input
            label={t('Order Number')}
            mandatory
            name="order-number"
            onChange={(event: any) => setOrderNumber(event.target.value)}
          />
          {!customer && (
            <Input
              label={t('Last Name')}
              mandatory
              name="last-name"
              onChange={(event: any) => setLastName(event.target.value)}
            />
          )}
        </div>
      </div>
      <div className={styles.actions}>
        <div className={styles.line}></div>
        <div className={styles.buttons}>
          <Button disabled={!orderNumber || (!customer?.lastName && !lastName)} onClick={handleClick} primary>
            {t('View Boarding Pass')}
          </Button>
          <ButtonTertiary dark onClick={() => props.onClose()}>
            {t('Cancel View Boarding Pass')}
          </ButtonTertiary>
        </div>
      </div>
    </>
  );
};

export default FindBoardingPass;
